import React from "react";

export default function Field({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  disabled = false,
}) {
  return (
    <label className="block">
      <div className="text-sm font-semibold text-slate-700 mb-1">{label}</div>
      <input
        type={type}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={[
          "w-full rounded-xl px-3 py-2 ring-1 ring-slate-200 bg-white",
          "focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-gray-800 dark:ring-gray-700/50 dark:focus:ring-gray-500/50",
          disabled ? "opacity-60 cursor-not-allowed" : "",
        ].join(" ")}
      />
    </label>
  );
}
